import * as React from 'react';
import { Alert } from '@grandvisionhq/common';

const NoStoresAlert = ({ labels , onClearAppointmentType  })=>/*#__PURE__*/ React.createElement(Alert, {
        className: "no-stores-alert",
        type: "warning",
        icon: "warning"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "alert__message"
    }, `${labels.message} `, /*#__PURE__*/ React.createElement("button", {
        className: "no-stores-alert__button",
        onClick: onClearAppointmentType
    }, labels.action), "."))
;
var NoStoresAlert$1 = NoStoresAlert;

export { NoStoresAlert$1 as default };
//# sourceMappingURL=NoStoresAlert.js.map
